import { render, staticRenderFns } from "./add-complex-menu-variant-modal.vue?vue&type=template&id=03c62243&scoped=true&"
import script from "./add-complex-menu-variant-modal.vue?vue&type=script&lang=ts&"
export * from "./add-complex-menu-variant-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c62243",
  null
  
)

export default component.exports